import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import pinia from './store';
import MaskaPlugin from './plugins/maska'
import { registerSW } from 'virtual:pwa-register'

const app = createApp(App);

// Configure NProgress
NProgress.configure({
  showSpinner: false,
  trickleSpeed: 100,
  minimum: 0.08,
  easing: 'ease',
  speed: 500,
  template: '<div class="bar" role="bar" style="background: blue; height: 3px;"><div class="peg"></div></div>'
});

// Register the service worker for PWA support
const updateSW = registerSW({
  onNeedRefresh() {
    window.dispatchEvent(new Event('app:sw-need-refresh'));
  },
  onOfflineReady() {
    console.log('App is ready to work offline.');
  }
});

window.addEventListener('app:sw-update-confirm', () => {
  updateSW(true);
});

// Router progress bar hooks
router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done();
});

// Make NProgress available globally if needed
app.config.globalProperties.$nprogress = NProgress;

// Register plugins
app.use(pinia);
app.use(router);
app.use(MaskaPlugin)
app.use(vuetify);

app.mount('#app');
